import { useTranslation } from 'next-i18next'
import React from 'react'

import Layouts from '@/layouts/Layouts'

import Banner from './Banner'
import ReportContent from './ReportContent'

const Report: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Layouts
      title={String(t('report:title'))}
      description={String(t('report:description'))}
    >
      <div className='min-h-screen w-full bg-white pt-14 lg:pt-18'>
        <Banner />
        <ReportContent />
      </div>
    </Layouts>
  )
}

export default Report
